export default {
  loginSchema__ACCOUNT_NUMBER_OR_USERNAME: "Account number or username",
  loginSchema__COMPANY_ID: "Company ID Number",
  loginSchema__ENTER_VALID_COMPANY_ID: "Enter a valid company ID.",
  loginSchema__ENTER_VALID_PASSWORD: "Enter a valid account password.",
  loginSchema__ENTER_VALID_USERNAME: "Enter a valid account number or username.",
  loginSchema__PASSWORD: "Password",
};
